/**
 * 业务状态码汇总
 * onepage和user两个服务状态码有区别
 * ws跟onepage一致
 */
/** 参数错误 */
export const PARAM_ERROR = -2;
/** 用户未登录onepage服务 */
export const USER_NOT_LOGIN = 920001;
/** 未知用户 */
export const USER_UNKNOWN = 920002;
/** 用户未登录user服务 */
export const USER_NOT_LOGIN_ACCOUNT = 100007;
/** 用户无权限 */
export const USER_NO_PERMISSION = 920004;
/** 临时文件只能对话一次 */
export const TEMP_FILE_ONLY_ONCE = 921009;
/** 被删除后访问，资源不存在， */
export const RESOURCE_NOT_FOUND = 920005;
/** 无权限继续发布网站，只能发布一个 */
export const USER_NO_PUBLICMORE = 9200011;
/** 未注册返回的业务状态码 */
export const UNREGISTERED_CODE = 110008;
/** 验证码错误 */
export const EMAIL_CODE_ERROR = 110003;
/** 无权限业务状态码 */
export const PERMISSION_ERROR = [USER_NOT_LOGIN, USER_NO_PERMISSION, USER_NOT_LOGIN_ACCOUNT, USER_UNKNOWN];
/** 用户名已存在 */
export const USER_NAME_EXISTS = 100005;
/** 验证码错误 */
export const VERIFY_CODE_ERROR = 110003;
/** 验证码过期 */
export const VERIFY_CODE_EXPIRE = 110002;
/** 每分钟请求达到上限 */
export const MIN_REQ_EXCEEDS_LIMIT = 110000;
/** 建站助手系统错误 */
export const ASSISTANT_SYSTEM_ERROR = 921001;
/** 扣除积分失败 */
export const CONSUME_ASSET_ERR = 922000;
/** 检查积分余额失败 */
export const CHECK_ASSET_ERR = 922001;
/** 积分不足 */
export const DIGITAL_NOT_ENOUGH = 922002;
/** 自定义域名重复 */
export const DOMAIN_DUPLICATION = 920008;
/** 自定义域名参数错误 */
export const DOMAIN_INVALID = 920006;
/** 自动更新 错误 */
export const AUTO_UPDATE_ERROR = 921011;
